import debounce from 'lodash.debounce'
import React, { useCallback, useEffect, useState } from 'react'

function search(term) {
  if (!term) {
    return []
  }

  return fetch(`/patients.json?search=${term}`).then((res) => res.json())
}

export default function PatientSearch(props) {
  const allowsSpecial = props.allowsSpecial ?? false
  const [patientName, setPatientName] = useState(props.patient?.name ?? '')
  const [patientPhone, setPatientPhone] = useState(props.patient?.phone ?? '')
  const [patientEmail, setPatientEmail] = useState(props.patient?.email ?? '')

  const [address, setAddress] = useState(props.patient?.address ?? '')
  const [city, setCity] = useState(props.patient?.city ?? '')
  const [state, setState] = useState(props.patient?.state ?? '')
  const [idCard, setIdCard] = useState(props.patient?.id_card ?? '')
  const [idCardExp, setIdCardExp] = useState(props.patient?.id_card_exp ?? '')

  const [results, setResults] = useState([])
  const [showDetails, setShowDetails] = useState(
    props.prescription_type === 'special'
  )

  const debouncedSearch = debounce(async (name) => {
    const res = await search(name)
    setResults(res)
  }, 500)

  const onNameChange = useCallback(
    async (name) => {
      setPatientName(name)
      await debouncedSearch(name)
    },
    [patientName]
  )

  const selectResult = (result) => {
    setPatientName(result.name)
    setPatientPhone(result.phone)
    setPatientEmail(result.email)

    setAddress(result.address)
    setCity(result.city)
    setState(result.state)
    setIdCard(result.id_card)
    setIdCardExp(result.id_card_exp)

    setResults([])
  }

  return (
    <div className="patient">
      <div className="field">
        <label htmlFor="patient">
          <i className="fal fa-user"></i>
          Paciente
        </label>

        <input
          required
          type="text"
          name="patient[name]"
          id="patient[name]"
          autoComplete="off"
          value={patientName}
          onChange={(e) => onNameChange(e.target.value)}
        />
      </div>

      {results.length > 0 && (
        <ul className="users-template-preview" style={{ display: 'block' }}>
          {results.map((result) => (
            <li key={result.id} onClick={() => selectResult(result)}>
              <span>{result.name}</span>
            </li>
          ))}
        </ul>
      )}

      <div className="field">
        <label htmlFor="patient[phone]">
          <i className="fal fa-phone"></i>
          Telefone do Paciente
        </label>

        <input
          required
          type="tel"
          name="patient[phone]"
          id="prescription_patient_phone"
          autoComplete="off"
          value={patientPhone}
          onChange={(e) => setPatientPhone(e.target.value)}
        />
      </div>

      <div className="field">
        <label htmlFor="patient[email]">
          <i className="fal fa-envelope-open"></i>
          Email do Paciente
        </label>

        <input
          required
          type="email"
          name="patient[email]"
          id="patient[email]"
          autoComplete="off"
          value={patientEmail}
          onChange={(e) => setPatientEmail(e.target.value)}
        />
      </div>

      <div className="field special-prescription">
        <label htmlFor="patient[id_card]">
          <i className="fal fa-id-card"></i>
          CPF do Paciente
        </label>

        <input
          name="patient[id_card]"
          id="patient[id_card]"
          autoComplete="off"
          value={idCard}
          onChange={(e) => setIdCard(e.target.value)}
        />
      </div>

      {allowsSpecial && (
        <div
          className="form-group check-box-group"
          style={{ marginBottom: '1em' }}
        >
          <input
            type="checkbox"
            value={showDetails}
            checked={showDetails}
            onChange={() => setShowDetails(!showDetails)}
          ></input>
          <label onClick={() => setShowDetails(!showDetails)}>
            Receituário Especial
          </label>
        </div>
      )}

      {showDetails && (
        <div className="special-prescription-container">
          <div className="disclaimer">
            <h4>👩‍⚕️ Atenção</h4>
            <p>Receituário especial requer assinatura manual.</p>
          </div>
          <input
            type="hidden"
            name="prescription[prescription_type]"
            value="special"
          />

          <div className="field special-prescription">
            <label htmlFor="patient[address]">
              <i className="fal fa-map-marker"></i>
              Logradouro
            </label>

            <input
              name="patient[address]"
              id="patient[address]"
              autoComplete="off"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>

          <div className="split">
            <div className="field special-prescription">
              <label htmlFor="patient[city]">
                <i className="fal fa-city"></i>
                Cidade
              </label>

              <input
                name="patient[city]"
                id="patient[city]"
                autoComplete="off"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>

            <div className="field special-prescription">
              <label htmlFor="patient[state]">
                <i className="fal fa-map"></i>
                UF
              </label>

              <input
                name="patient[state]"
                id="patient[state]"
                autoComplete="off"
                value={state}
                onChange={(e) => setState(e.target.value)}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
